import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'commercials/shop';
const wizardName = 'Shop deduplicate';
const wizardAction = 'deduplicate';

const Deduplicate = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);

    const { doAction, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, true);
    const modelName = existingModules.modelName;

    const detailConfig = {
        "tabs": [
            {
                "name": "document",
                "fieldsets": [
                    {
                        "name": "document",
                        "fields": {
                            "info": {
                                "type": "sectionmessageblock",
                                "title": "select_shopchampion_title",
                                "paragraph": "select_shopchampion_paragraph",
                                "icon": "faMerge",
                                "className": "col-12 info",
                            },
                            "champion": {
                                "type": "shoplist",
                                "required": true,
                                "className": "col-12",
                                "disableMultipleRowSelection": true,
                                "hideTableToolbar": true,
                                "filters": {
                                    "items": [
                                        {
                                            "field": "_original_id",
                                            "operator": "in",
                                            "value": params.selected
                                        }
                                    ]
                                }
                            }
                        }
                    }
                ]
            }
        ],
        "validation": []
    };

    useEffect(() => {
        if (success) {
            close();
        }
    }, [success]);

    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data })
            .then((response) => params.handleClose(params.uid, response.item.data))
            .catch(() => console.error('catch handleSave'));
    };

    return (
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{
                "selected": params.selected,
            }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Deduplicate shops')}
                />
            }
            {...params}
        />
    );
};

export default Deduplicate;
